import { makeVar } from '@apollo/client';

export const globalRefreshNotificationVar = makeVar<boolean>(false);
